/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {  
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Nirmal Portfolio",
  description:
    "A passionate Software Engineer having an experience in building, training, tuning and deploying algorithmic models using Deep Learning and Machine Learning. Loves to automate the stuffs.",
  og: {
    title: "Nirmal Silwal Portfolio",
    type: "website",
    url: "http://nirmalsilwal.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Nirmal Silwal",
  logo_name: "Nirmal Silwal",
  nickname: "baba👋",
  subTitle:
    "A passionate Software Engineer having an experience in building, training, tuning and deploying algorithmic models using Deep Learning and Machine Learning. Loves to automate the stuffs. Currently I am exploring Algorithms, Java and some web development.🚀🚀",
    resumeLink:
    "https://drive.google.com/file/d/1CyQ02SwCmZBNpkO9b64ExOny6zAXBJWX/view?usp=sharing",
  portfolio_repository: "https://github.com/NirmalSilwal",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/nirmal-silwal/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Github",
    link: "https://github.com/NirmalSilwal",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Gmail",
    link: "mailto:nirmalsilwal2019@gmail.com",
    fontAwesomeIcon: "fas fa-envelope", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/silwal_nirmal",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Whatsapp",
    link: "https://api.whatsapp.com/send?phone=+9779840079490",
    fontAwesomeIcon: "fa-whatsapp", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#25D366", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/nirmal.silwal.96/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Skype",
    link: "https://join.skype.com/invite/nQ6L87hDAw9k",
    fontAwesomeIcon: "fa-skype", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#00AFF0", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Quora",
    link: "https://www.quora.com/profile/Nirmal-Silwal-1",
    fontAwesomeIcon: "fa-quora",
    backgroundColor: "#B92B27",
  },
  /*
  {
    name: "Instagram",
    link: "https://www.instagram.com/nirmal_silwal97",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/c/NirmalSilwal",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  }
  */
];

const skills = {
  data: [
    {
      title: "Deep Learning and ML",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various Deep Learning and statistical use cases",
        "⚡ Experience working with various unstructured data like images and texts",
        "⚡ Experience working with ML and NLP projects",
        "⚡ Good exposure of AI lifecycle from data gathering, data cleaning & preparation, model building, model training, hyperparameter tuning and model deployment"
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    
    /*
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    */
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        //"⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on AWS Sagemaker",
        "⚡ Native to Linux environment",
        //"⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        /*
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        */
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        /*
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        */
      ],
    },
    {
      title: "Basic Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building simple webpages using HTML, CSS and Bootstrap",
        "⚡ Creating simple webpage to demonstrate Deep Learning projects to clients",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },        
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "logos:bootstrap",
          style: {
            color: "transparent",
          },
        },
      ],
    },
  
    /*
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    }, 
    */
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#FFA116",
      },
      profileLink: "https://leetcode.com/NirmalSilwal",
    }, 
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/nirmal_silwal",
    },   
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/nirmal_silwal",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/NirmalSilwal",
    },
    /*
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@nirmaldeepsil.11",
    },
    
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
    */
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dr. A.P.J. Abdul Kalam Technical University",
      subtitle: "B.Tech. in Computer Science & Engineering",
      logo_path: "uptu_logo.png",
      alt_name: "ABSS Institute of Technology",
      duration: "2014 - 2018",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like Data Structures, Algorithms, Automata, OS, DBMS, Computer Network, AI, Distributed System, etc.",
        "⚡ Apart from this, I have done courses on Java programming, web development and Big Data technologies.",
        "⚡  I was the batch topper & class topper in entire 4 years of study and have received honor degree.",
      ],
      website_link: "https://www.abss.edu.in/",
    },

    {
      title: "CDAC - SM VITA",
      subtitle: "Post Graduate Diploma in Big Data Analyltics",
      logo_path: "cdac_logo.jpg",
      alt_name: "Vidyanidhi Infotech",
      duration: "2018 - 2019",
      descriptions: [
        "⚡ Learned and implemented various cutting edge technologies like Machine Learning, Python, Statistics, Big Data, Hadoop, Linux, Cloud computing, Java programming.",
        "⚡ Build the data pipelines in GCP to setup the project in Machine Learning.",
        "⚡ Setup the Hadoop cluster from scratch and using Dataproc.",          
      ],
      website_link: "https://vidyanidhi.com/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Deep Learning Nanodegree",
      subtitle: "- UDACITY",
      logo_path: "udacitylogo.png",
      certificate_link:
        "https://drive.google.com/file/d/1mrITu-0chQaQ7pBtc6OaZveqq1qWmMOd/view",
      alt_name: "UDACITY",
      color_code: "transparent",
    },
    {
      title: "Big Data in the Age of AI",
      subtitle: "- Linkedin Learning",
      logo_path: "linkedin-logo.png",
      certificate_link:
        "https://drive.google.com/file/d/15zjuJZCYwsXxHe6GGXjnz93or49MWnVZ/view",
      alt_name: "Linkedin learning",
      color_code: "#0A66C2",
    },
    {
      title: "Fundamentals of Deep Learning for Computer Vision",
      subtitle: "- NVIDIA training",
      logo_path: "nvidia-logo.png",
      certificate_link:
        "https://courses.nvidia.com/certificates/4f54362b3efd4ae989a35b94f85fc407",
      alt_name: "NVIDIA",
      color_code: "",
    },
    {
      title: "End-to-End Machine Learning with Tensorflow on GCP",
      subtitle: "- Google Cloud Training",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/PSR7ZRQW2EJA",
      alt_name: "Coursera certification",
      color_code: "#0056D2",
    },
    {
      title: "Complete Python Developer in 2020: Zero to Mastery",
      subtitle: "- Andrei Neagoie",
      logo_path: "udemy-logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-4588a634-530d-4288-aa79-63f9f93a0686/",
      alt_name: "Udemy",
      color_code: "#A435F0",
    },
    {
      title: "Tensorflow 2.0: Deep Learning and Artificial Intelligence",
      subtitle: "- Lazy Programmer",
      logo_path: "udemy-logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-S3PLCE2X/",
      alt_name: "Udemy",
      color_code: "#A435F0",
    },    
    {
      title: "Google Cloud Trainings",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/c5f15a5e-e6fa-452f-8e03-d76c4d47b85b",
      alt_name: "Qwicklabs profile, GCP training",
      color_code: "transparent",
    },
    {
      title: "Programming in Java",
      subtitle: "- NIIT",
      logo_path: "niit-logo.png",
      certificate_link:
        "https://drive.google.com/drive/folders/1m0WRTbHTm6Zz4VW-aMHlywmHRM1hy4RH?usp=sharing",
      alt_name: "NIIT",
      color_code: "",
    },
    {
      title: "Core + Advance Java",
      subtitle: "- Tech Mentro",
      logo_path: "techmentro-logo.png",
      certificate_link:
        "",
      alt_name: "Tech Mentro Java training",
      color_code: "#0C9D5899",
    },
    /*
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    */
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Proficiency, Work and Extracurriculars",
  description:
  "I have worked as Software engineer in the product based company where I get to solve the complex problems using Python, Deep Learning and AWS cloud. I have good exposure to DL and ML lifecycle. Thanks to Python, I can automate the boring stuffs easily.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "LearningMate",
          company_url: "https://learningmate.com/",
          logo_path: "LearningMate-logo.png",
          duration: "April 2019 - Jan 2020",
          location: "Mumbai",
          description:
            "LearningMate is the US  based company working in Education domain. My major responsibilities were building Deep Learning models to automate the Image Captioning process. I have primarily done the data preparation, data cleaning, model building, model training and fine tuning the models to deliver the better results. I also created various synthetic tabular data for model building. I automated various tasks for e-books in multiple projects for different teams. I was also involved in teams for Visual Search and Natural Language Generation projects.",
          color: "#0879bf",
        },
        /*
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description:
            "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
        */
      ],
    },
    {
      title: "Internship",
      experiences: [
        {
          title: "Big Data Trainee",
          company: "KARD India",
          company_url: "https://www.linkedin.com/company/kard-india/about/",
          logo_path: "kardIndia-logo.png",
          duration: "June 2017 - July 2017",
          location: "Noida Sector-4",
          description:
            "KARD India is the researach organization that also provides training to the students. I get to learn various Big Data technologies. My major tasks includes setting up the Hadoop clusters from scratch to writing various scripts to solve the Big Data problems. I get to work in Hadoop, HDFS, MapReduce, Apache Pig, Flume, Hive, Sqoop.",
          color: "#ee3c26",
        },
        /*
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url:
            "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        },
        */
      ],
    },
    {
      title: "Extracurriculars",
      experiences: [
        {
         title: "ABSS Institute of Technology",
          company: "Student",
          company_url: "https://www.abss.edu.in/",
          logo_path: "abss-logo.jfif",
          duration: "2014 - 2018",
          location: "Meerut, U.P.",
          description:
            "While pursuing my BTECH degree, I get to involve in various curricular activities. In the annual college function CONFLUENCE, our team was able to win various competitions. Our team of three won the 'Live Project' contest where we presented the 'Line Following Robot' using Arduino that runs in the specific line. We won the 'Best Out of Waste' challenge where we utilized the waste products of the college surroundings like Plastics, wrappers, some grass and flowers. I was also the 'Mr. Farewell' of our batch. I was also the runnerup of Codejam event where we have to identify the output and debug the code written in C language.",
          color: "#4285F4",
        },
        /*
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
        */
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology  tools. My best experience is to create Deep Learning and ML projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};
/*
const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};
*/
 
// Contact Page
const contactPageData = {
  contactSection: {
    title: "Let's get connected",
    profile_image_path: "nirmal-profile.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Deep Learning, Machine Learning, Java, Python, Linux, Cloud, basic web development and Open source development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I write about programming and various technologies. I have posts on software engineering, ML, AI, Big Data.",
    link: "https://flipcartnepal.wordpress.com/",
    avatar_image_path: "blogs_image.svg",
  },  
  addressSection: {
    title: "Address",
    subtitle:
      "Ichhakamana, Kurintar, Chitwan, Nepal",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/BWDrAKEupUQBmg8M7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+977 9840079490 (Whatsapp, Viber)",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  // publicationsHeader,
  contactPageData,
};
